import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { Lang } from '@common/typescript/objects/Lang';
import { handleUrl } from '@common/react/utils/FIltersParamsFromUrl/FiltersParamsFromUrl';
import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';

import { capitalizeFirstLetter } from '@app/components/Utils';
import BeforeAfterList from '@app/components/Pages/BeforeAfterList/BeforeAfterList';

interface Service {
	id: number;
	title: string;
	image: string;
	imageWebp: string;
	link?: string;
}

const services: Array<Partial<Service>> = [
	{
		image: '/amp-assets/images/1.webp',
		imageWebp: '/amp-assets/images/1_m.webp',
	},
	{
		image: '/amp-assets/images/3.webp',
		imageWebp: '/amp-assets/images/3_m.webp',
	},
];

const BeforeAfterPreview: React.FC<{ serverPage }> = ({ serverPage }) => {
	const { i18n } = useTranslation();
	const langString: 'En' | 'Es' = capitalizeFirstLetter(i18n.language);
	const navigate = useNavigate();
	const location = useLocation();

	return <div className="before-after case-page">
		<div className="container case-page__container case-page__banner">
			<div className="row case-page-sections">
				{services.map((item, index) => {
					const page = serverPage?.servicePages?.[index];
					if (!page) return;

					return <div
						key={page.id}
						className="col-xs-6 col-md-3"
					>
						<a
							onClick={(e) => {
								e.preventDefault();
								page.id && handleUrl({ pageIds: [page.id] }, location, navigate);
							}}
							className="case-page-sections-item"
						>
							<picture>
								<source media="(max-width: 768px)" srcSet={item.imageWebp} />
								<source media="(min-width: 769px)" srcSet={item.image} />
								<img className="case-page-sections-item__image" srcSet={item.image} alt="" />
							</picture>
							<div className="case-page-sections-item__title">
								{(Lang[langString] === Lang.Es) ? page.shortNameEs : page.shortNameEn}
							</div>
						</a>
					</div>;
				})}
			</div>
		</div>
	</div>;
};

const BeforeAfter: React.FC = () => {
	const location = useLocation();
	const [initLoad, setInitLoad] = React.useState(!location.search);

	return <ServerPageProvider
		inner={(serverPage) => (location.search || !serverPage?.servicePages?.length
			? <BeforeAfterList initLoad={serverPage?.servicePages?.length ? initLoad : false} serverPage={serverPage} />
			: <BeforeAfterPreview serverPage={serverPage} />)
		}
	/>;
};

export default BeforeAfter;
